import { ActivityIndicator, Flex, Modal } from 'antd-mobile'
import cardValidator from 'card-validator'
import cx from 'classnames'
import helpers from 'helpers'
import * as _ from 'lodash'
import * as moment from 'moment'
import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { CardCVCElement, CardExpiryElement, CardNumberElement } from 'react-stripe-elements'
import styles from '../assets/styles/components/TakeawayPaymentSummary'
import CCBCards from '../constants/ccbCards'
import { DELIVERY_TYPE_DELIVERY, MERCHANT_TIM_GEI, FIRST_DATA_MERCHANTS } from '../constants/merchant'
import { PAYMENT_GATEWAY_STRIPE, PAYMENT_GATEWAY_FIRST_DATA } from '../constants/app'
import DialogComponent from './../containers/hoc/Dialog'
import { FirstDataCreditCard, FirstDataApplePay, FirstDataGooglePay } from './first-data'
import QrcPayment from './wechatpay/QrcPayment'
import withToast from './hoc/Toast'
import Toast from './Toast'
import { loadState, getStorage } from '../store/localStorage'
import orderApi from 'services/api/order'
import { isMobileOnly } from 'react-device-detect'
const ToastComponent = withToast(Toast)

class TakeawayPaymentSummaryComponent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      firstLoad: true,
      qrcode: '',
      payUrl: '',
      amount: 0,
      paymentMethod: null,
      ignoreUnavailable: false,
      displayPayCashDialog: false,
      displayQRC: false,
      innerHeight: window.innerHeight,
      cardHolder: '',
      paymentRequest: null,
      isCardNumComplete: false,
      isCardExpireDateComplete: false,
      isCardCVCComplete: false,
      isSubmittingPayment: false,
      isShowReorderBtn: false,
      isRenderToast: false,
      toastMessage: '',
      toastType: 'fail',
      card: {
        number: '',
        holder: '',
        cvv: '',
        expiration: '',
      },
      submittingWechatPay: false,
      paymentReady: false,
      wc_payload: {},
    }
    this.isCampaignCCBMerchant = false
    if (window.location.hostname.includes('localhost') || window.location.hostname.includes('takebypass')) {
      window.TakeawayPaymentSummaryComponentBypassSubmit = () => {
        this.submit({ payment: 'bypass', source: 'dimdan' })
      }
    }
    this.handleDisplayQRC = this.handleDisplayQRC.bind(this)
  }

componentDidMount = async () => {
  const { childRef, stripe, merchant, orders, basket, shouldShowWeChatPayBtn, shouldShowAliPayBtn } = this.props
  const { firstLoad } = this.state
  childRef(this)

  const result = helpers.calculate.calculateOrders(orders, merchant, basket.discount, basket.shipping)

  const { discountedTotal, discountedTotalWithShipping } = result
  let amount = discountedTotal
  if (basket.isShop || basket.isStoreDelivery) {
    amount = discountedTotalWithShipping
    if (basket.shipping.freightCollect) {
      amount = discountedTotal
    }
  }
  amount = Math.round(Math.max(0, amount * 100)) // $ to cents

  const paymentRequest = stripe.paymentRequest({
    country: 'HK',
    currency: 'hkd',
    total: {
      label: '外賣',
      amount,
    },
    requestPayerName: false,
    requestPayerEmail: false,
  })

  paymentRequest.on('token', async (payload) => {
    try {
      console.log('tokennn')
      const method = payload.token.card.brand
      await this.submitByPayToken(method, payload.token.id)
      payload.complete('success')
    } catch (err) {
      payload.complete('fail')
    }
  })

  this.setState({
    amount,
    paymentRequest,
  })

  if (firstLoad) {
    // await this._makeWechatPayment()
    // await this._makeAliPayment()
    this.setState({ firstLoad: false, paymentReady: true })
  }

  // if (shouldShowWeChatPayBtn) {
  //   this.timer = setInterval(async () => {
  //     await this._makeWechatPayment()
  //   }, 30 * 1000)
  // }
  // if (shouldShowAliPayBtn) {
  //   this.aliTimer = setInterval(async () => {
  //     await this._makeAliPayment()
  //   }, 30 * 1000)
  // }
  window.addEventListener('resize', this.updateDimensions)
}

updateDimensions = () => {
  this.setState({ innerHeight: window.innerHeight })
}

componentDidUpdate = (prevProps) => {
  if (!this.state.submittingWechatPay && this.props.wechatPaySuccess === true) {
    this.setState({ submittingWechatPay: true })
    // TODO: call once
  }
  if (
    !prevProps.soldOut.displaySoldOutDialog.takeawayPaymentSummary &&
      this.props.soldOut.displaySoldOutDialog.takeawayPaymentSummary &&
      this.props.soldOut.soldOutItems
  ) {
    this.setState({ isSubmittingPayment: false })
    this.renderSoldOutDialog()
  }

  if (!prevProps.campaign.ccb.displayCCBCardOnlyDialog && this.props.campaign.ccb.displayCCBCardOnlyDialog) {
    this.setState({ isSubmittingPayment: false })
    this.renderCCBCardOnlyDialog()
  }
}

componentWillUnmount = () => {
  const { shouldShowWeChatPayBtn, shouldShowAliPayBtn } = this.props

  this.setState({ paymentRequest: null, firstLoad: true })
  if (shouldShowWeChatPayBtn) {
    clearInterval(this.timer)
  }
  if (shouldShowAliPayBtn) {
    clearInterval(this.aliTimer)
  }

  window.removeEventListener('resize', this.updateDimensions)
}

shouldShowCreditCard = (merchant) => {
  const merchants = [MERCHANT_TIM_GEI]
  return !merchants.includes(_.get(merchant, 'id'))
}

// > 當 payment method button onclick 的時候紀錄他選了那個
// > 當 submit 收到 error status 500 (部分商品完售) 時開啟 soldout dialog
// > 當點擊 soldout dialog 的 continue button 時，根據 state 內的 paymentMethod 發送不同的 submit
// > 關閉 soldout dialog 時把 paymentMethod 重設
handleSetStatePaymentMethod = (paymentMethod) => {
  this.setState({ paymentMethod: paymentMethod })
}

preSubmit = async ({ payment, source, gateway, payload, syssn, out_trade_no } = {}) => {
  const { history, user, merchant, basket, orders } = this.props
  let { pickupAt, dropoffat, deliveryType, deliveryAddress } = this.props
  let address = this.props.user.address
  const wc_payload = getStorage('wc_payload')
  if (!_.isEmpty(wc_payload)) {
    ;({ pickupAt, deliveryType, address, dropoffat } = wc_payload)
  } else if (deliveryType === DELIVERY_TYPE_DELIVERY) {
    pickupAt = moment(dropoffat).subtract(30, 'minute').format()
    address = deliveryAddress
  } else {
    dropoffat = undefined
  }

  try {
    await this.props.submitTakeawayBasket({
      preSubmit: true,
      merchant,
      deliveryType,
      id: basket.id,
      uuid: basket.uuid,
      // shipping: basket.shipping,
      promoCode: basket.promoCode,
      items: orders,
      remark: orders.remark,
      needTableware: user.needTableware,
      card: this.state.card,
      ignoreUnavailable: this.state.ignoreUnavailable,
      payment: {
        paymentMethod: payment,
        gateway,
        payload,
      },
      takeawayInfo: {
        payment,
        source,
        syssn,
        out_trade_no,
        pickupAt,
        scheduleAt: _.get(basket, 'shipping.scheduleAt'),
        dropoffAt: dropoffat,
        name: user.name,
        phone: user.tel,
        lat: user.lat,
        lng: user.lng,
        address, // google autocomplete address, without optional informations such as floor or room number
        floorRoom: user.floorRoom, // optional, default is empty string
        building: user.companyBuilding, // optional, default is empty string
        district: user.district, // from Marc pricing API, stops
        shipping: basket.shipping, // from Marc pricing API
      },
    })
    return true
  } catch (err) {
    console.log('submitTakeawayBasket error', JSON.stringify(err))

    let errMsg = this.props.intl.formatMessage(
      { id: `error.${(err && err.error) || 'general'}` },
      { ...(err && err.values) },
    )
    // check any stripe error
    const errCode = _.get(helpers.json.parse(_.get(err, 'data.error')), 'code')
    if (errCode) {
      const msg = this.props.intl.formatMessage({ id: 'error.stripe.' + errCode })
      if (msg !== 'error.stripe.' + errCode) {
        errMsg = msg
      }
    }
    if (err.isRenderToast === false) {
    } else {
      this.setState({
        isSubmittingPayment: false,
        isRenderToast: true,
        toastMessage: errMsg,
      })
    }
    return false
  }
}

submit = async ({ payment, source, gateway, payload, syssn, out_trade_no } = {}) => {
  const { history, user, merchant, basket, orders } = this.props
  let { pickupAt, dropoffat, deliveryType, deliveryAddress } = this.props
  let address = this.props.user.address
  const wc_payload = getStorage('wc_payload')
  if (!_.isEmpty(wc_payload)) {
    ;({ pickupAt, deliveryType, address, dropoffat } = wc_payload)
  } else if (deliveryType === DELIVERY_TYPE_DELIVERY) {
    pickupAt = moment(dropoffat).subtract(30, 'minute').format()
    address = deliveryAddress
  } else {
    dropoffat = undefined
  }
  try {
    await this.props.submitTakeawayBasket({
      merchant,
      deliveryType,
      id: basket.id,
      uuid: basket.uuid,
      // shipping: basket.shipping,
      promoCode: basket.promoCode,
      items: orders,
      remark: orders.remark,
      needTableware: user.needTableware,
      card: this.state.card,
      ignoreUnavailable: this.state.ignoreUnavailable,
      payment: {
        paymentMethod: payment,
        gateway,
        payload,
      },
      takeawayInfo: {
        payment,
        source,
        syssn,
        out_trade_no,
        pickupAt,
        scheduleAt: _.get(basket, 'shipping.scheduleAt'),
        dropoffAt: dropoffat,
        name: user.name,
        phone: user.tel,
        lat: user.lat,
        lng: user.lng,
        address, // google autocomplete address, without optional informations such as floor or room number
        floorRoom: user.floorRoom, // optional, default is empty string
        building: user.companyBuilding, // optional, default is empty string
        district: user.district, // from Marc pricing API, stops
        shipping: basket.shipping, // from Marc pricing API
      },
    })

    // no other methodT_T
    // window._justSubmittedOrder = true;
    // setTimeout(() => {
    //   window._justSubmittedOrder = false;
    // }, 3000);

    await this.props.resetStash()
    await this.props.resetOrder()
    await this.props.updatePromocodes(null)
    await this.props.setForm({})
    clearInterval(this.timer)
    clearInterval(this.aliTimer)
    if (payment === 'wechatpay') {
      return true
    }
    console.log('history.replace to takeaway_waiting')
    history.replace({
      pathname: '/basket/takeaway_waiting',
      state: {
        from: history.location.pathname,
      },
    })
  } catch (err) {
    console.log('submitTakeawayBasket error', JSON.stringify(err))

    let errMsg = this.props.intl.formatMessage(
      { id: `error.${(err && err.error) || 'general'}` },
      { ...(err && err.values) },
    )
    // check any stripe error
    const errCode = _.get(helpers.json.parse(_.get(err, 'data.error')), 'code')
    if (errCode) {
      const msg = this.props.intl.formatMessage({ id: 'error.stripe.' + errCode })
      if (msg !== 'error.stripe.' + errCode) {
        errMsg = msg
      }
    }
    if (err.isRenderToast === false) {
    } else {
      this.setState({
        isSubmittingPayment: false,
        isRenderToast: true,
        toastMessage: errMsg,
      })
    }
  }
}

  submitByCash = async () => {
    const { intl } = this.props
    try {
      this.submit({ payment: 'cash' })
    } catch (err) {
      this.setState({
        isRenderToast: true,
        toastMessage: intl.formatMessage(
          // eslint-disable-next-line no-mixed-operators
          { id: `error.${(err && err.error) || 'general'}` },
        ),
      })
    }
  }

  submitByRecentMethod = async (payment, gateway, custId) => {
    let error
    try {
      this.submit({ payment, source: custId, gateway })
    } catch (err) {
      error = err || true
      throw error
    }
  }

  submitByPayToken = async (paymentType, token) => {
    // Card brand. Can be American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown.
    const paymentTypeMap = {
      'American Express': 'ae',
      'Diners Club': 'diners_club',
      JCB: 'jcb',
      MasterCard: 'master',
      UnionPay: 'unionpay',
      Visa: 'visa',
      Unknown: 'unknown',
    }
    const payment = paymentTypeMap[paymentType] ? paymentTypeMap[paymentType] : 'unknown'
    return this.submit({ payment, source: token, gateway: PAYMENT_GATEWAY_STRIPE })
  }

  payWithRecentMethod = () => {
    const { recentPaymentInfo } = this.props
    this.handleSetStatePaymentMethod('recent')
    if (recentPaymentInfo.token) {
      this.submitByRecentMethod(recentPaymentInfo.method, PAYMENT_GATEWAY_FIRST_DATA, recentPaymentInfo.token)
    } else {
      this.submitByRecentMethod(recentPaymentInfo.method, PAYMENT_GATEWAY_STRIPE, recentPaymentInfo.custId)
    }
  }

payWithCreditCardInfo = async () => {
  const { stripe, intl } = this.props

  if (stripe) {
    this.setState({ isSubmittingPayment: true })
    try {
      const payload = await stripe.createToken({
        name: this.state.cardHolder,
      })
      if (_.get(payload, 'error')) {
        throw payload.error
      }
      if (!payload || !payload.token) {
        throw new Error('invalid token')
      }
      await this.submitByPayToken(payload.token.card.brand, payload.token.id)
    } catch (err) {
      console.error(err)
      let errMsg = intl.formatMessage({ id: 'error.general' })
      const errCode = _.get(helpers.json.parse(_.get(err, 'data.error')), 'code')
      if (errCode) {
        const msg = intl.formatMessage({ id: 'error.stripe.' + errCode })
        if (msg !== 'error.stripe.' + errCode) {
          errMsg = msg
        }
        this.setState({
          isSubmittingPayment: false,
          isRenderToast: true,
          toastMessage: errMsg,
        })
      }
    }
  }
}

payWithCCBCreditCardInfo = async (cardType) => {
  const { intl } = this.props
  this.setState({ isSubmittingPayment: true })
  try {
    await this.submitByPayToken(cardType, '')
  } catch (err) {
    console.error(err)
    let errMsg = intl.formatMessage({ id: 'error.general' })
    const errCode = _.get(helpers.json.parse(_.get(err, 'data.error')), 'code')
    if (errCode) {
      const msg = intl.formatMessage({ id: 'error.stripe.' + errCode })
      if (msg !== 'error.stripe.' + errCode) {
        errMsg = msg
      }
      this.setState({
        isSubmittingPayment: false,
        isRenderToast: true,
        toastMessage: errMsg,
      })
    }
  }
}

payWithApplePay = () => {
  this.state.paymentRequest.canMakePayment().then((result) => {
    if (result) {
      this.state.paymentRequest.show()
    }
  })
}

payWithGooglePay = () => {
  this.state.paymentRequest.canMakePayment().then((result) => {
    if (result) {
      this.state.paymentRequest.show()
    }
  })
}

  _makeAliPayment = async () => {
    const { basket, orders, deliveryType, deliveryAddress, pickupAt, dropoffat, merchant } = this.props
    const { card, ignoreUnavailable } = this.state.card
    const isMobile = isMobileOnly

    const { state, aliPayload } = await this.props.makeAliPayment({
      isMobile,
      basket,
      deliveryType,
      deliveryAddress,
      pickupAt,
      dropoffat,
      card,
      ignoreUnavailable,
      orders,
      merchant,
    })
    this.setState(state)
    this.setState({ aliPayload: aliPayload })
    return Promise.resolve(true)
  }

  _makeWechatPayment = async () => {
    const { basket, orders, deliveryType, deliveryAddress, pickupAt, dropoffat, merchant } = this.props
    const { card, ignoreUnavailable } = this.state.card
    const isMobile = isMobileOnly

    const { state, wc_payload } = await this.props.makeWechatPayment({
      isMobile,
      basket,
      deliveryType,
      deliveryAddress,
      pickupAt,
      dropoffat,
      card,
      ignoreUnavailable,
      orders,
      merchant,
    })
    this.setState(state)
    this.setState({ wc_payload: wc_payload })
    return Promise.resolve(true)
  }

payWithAlipay = async () => {
  const { aliPayload } = this.state
  console.log(aliPayload)
  const token = loadState().user.token
  const isMobile = isMobileOnly
  clearInterval(this.aliTimer)
  let isReady = false
  if (aliPayload.payUrl === '') {
    isReady = await this._makeAliPayment()
  } else {
    isReady = true
  }
  if (isReady) {
    if (!isMobile) {
      this.setState({
        QRCType: 'alipay',
        displayQRC: !this.state.displayQRC,
      })
    } else {
      const localStorageToServer = {
        state: loadState(),
        aliPayload: this.state.aliPayload,
      }
      await orderApi.saveCache(this.state.outTradeNo, localStorageToServer, token).then(async (res) => {
        const submitResult = await this.submit({
          payment: 'alipay',
        })
        if (submitResult) {
          setTimeout(() => {
            window.location.replace(
              this.state.aliPayload.payUrl,
            )
          }, 500)
        }
      })
    }
  }
}

payWithWeChatPay = async () => {
  const { qrcode, payUrl } = this.state
  const token = loadState().user.token
  const isMobile = isMobileOnly
  clearInterval(this.timer)
  let isReady = false
  if (qrcode === '' && payUrl === '') {
    isReady = await this._makeWechatPayment()
  } else {
    isReady = true
  }
  if (isReady) {
    if (!isMobile) {
      this.setState({
        QRCType: 'wechatpay',
        displayQRC: !this.state.displayQRC,
      })
    } else {
      const localStorageToServer = {
        state: loadState(),
        wc_payload: this.state.wc_payload,
      }
      await orderApi.saveCache(this.state.outTradeNo, localStorageToServer, token).then(async (res) => {
        const submitResult = await this.submit({
          payment: 'wechat',
        })
        console.log('submitResult', submitResult)
        if (submitResult) {
          setTimeout(() => {
            window.location.replace(
              this.state.payUrl +
                '&redirect_url=' +
                encodeURIComponent(
                  `${window.location.protocol}//${window.location
                    .hostname}/wechatpay_confirmation?cid=${this.state.outTradeNo}`,
                ),
            )
          }, 500)
        }
      })
    }
  }
}

  handleDisplayQRC = () => {
    this.setState({ displayQRC: !this.state.displayQRC })
  }

  handleUpdateCardHolder = (e) => {
    this.setState({ cardHolder: e.target.value })
  }

  calculateAmount = () => {
    const { merchant, orders, basket } = this.props
    const { discountedTotal, discountedTotalWithShipping } = helpers.calculate.calculateOrders(
      orders,
      merchant,
      basket.discount,
      basket.shipping,
    )
    let amount = discountedTotal
    if (basket.isShop || basket.isStoreDelivery) {
      amount = discountedTotalWithShipping
    }
    return amount
  }

  renderToast = () => {
    if (this.state.isRenderToast) {
      return (
        <ToastComponent
          toastType={this.state.toastType}
          duration={5}
          message={this.state.toastMessage}
          callback={this.resetToast}
        />
      )
    }
  }

  resetToast = () => {
    this.setState({
      isRenderToast: false,
      toastMessage: '',
      isSubmittingPayment: false,
    })
  }

  handleCardNumberChanged = (event) => {
    this.setState({
      isCardNumComplete: event.complete,
    })
  }

  handleCardExpireDateChanged = (event) => {
    this.setState({
      isCardExpireDateComplete: event.complete,
    })
  }

  handleCardCVCChanged = (event) => {
    this.setState({
      isCardCVCComplete: event.complete,
    })
  }

  renderPaymentOptions = () => {
    const {
      classes,
      intl,
      shouldShowApplePayBtn,
      shouldShowGooglePayBtn,
      shouldShowCashBtn,
      shouldShowWeChatPayBtn,
      shouldShowAliPayBtn,
      shouldShowFpsBtn,
      merchant,
      campaign,
      updateDisplayCCBCardOnlyDialog,
      basket,
    } = this.props

    const { card } = this.state
    if (!merchant) return <div />
    this.isCampaignCCBMerchant = Boolean(campaign.ccb.merchants.find((m) => m.id === merchant.id))

    const optionStyle = cx(classes['payment-option-wrap'])
    const paymentOptionStyle = cx(classes['payment-option'])
    const disabledPaymentOptionStyle = cx(classes['payment-option'], classes.disabled)
    // const cashPaymentStyle = cx(classes['payment-option-cash'])
    // visa,master,ae
    const creditCardStyle = cx(classes['payment-option-credit-card'])
    const weChatPayStyle = cx(classes['payment-option-wechatpay'])
    const aliPayStyle = cx(classes['payment-option-alipay'])
    const applePayStyle = cx(classes['payment-option-apple-pay'])
    const gPayStyle = cx(classes['payment-option-g-pay'])
    const telInputStyle = cx(classes['takeaway-summary-tel-input'])
    const fpsStyle = cx(classes['payment-option-fps'])
    const _cardNumPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.cardnum_placeholder' })
    const _cardHolderPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.cardholder_placeholder' })
    const _cardExpirationPlaceholderText = intl.formatMessage({
      id: 'takeaway.summary.card_expiration_placeholder',
    })
    const _cardCVVPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.ccv_placeholder' })

    const valid =
      this.state.isCardNumComplete &&
      this.state.isCardExpireDateComplete &&
      this.state.isCardCVCComplete &&
      !this.state.isSubmittingPayment

    const footerStyle = valid
      ? cx(classes['takeaway-summary-footer'])
      : cx(classes['takeaway-summary-footer-invalid'])

    const selectStyle = cx(classes['takeaway-summary-select'])
    const reorderStyle = cx(classes['takeaway-summary-reorder-btn'])

    const _payText = intl.formatMessage({ id: 'footer.takeaway.confirm.pay' })
    const _reorderText = intl.formatMessage({ id: 'takeaway.reorder' })
    const merhcantList = [
      '7d4ee711-cb14-4077-8f3f-d0e762e0f870',
      '2e5a94f3-6820-42d3-ae7b-fae6d47743fa',
      '9aa25313-03c2-4c6e-92ef-9e68c8caf76c',
      '27b6aa86-fef1-4aa0-8340-31389937fd9e',
      '45297b9d-b4e6-4846-a784-2eb0f1a92299',
    ]
    const cashPaymentText = merhcantList.includes(merchant.id) ? intl.formatMessage({ id: 'takeaway.payment.method.cashier' }) : intl.formatMessage({ id: 'takeaway.payment.method.cash' })
    const creditCardPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.creditCard' })
    // const weChatPayPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.wechatPay' })
    // const aliPayPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.alipay' })
    const applePayPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.applePay' })
    const googlePayPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.googlePay' })
    // const fpsPaymentText = intl.formatMessage({ id: 'takeaway.payment.method.fps' })
    // const cvvPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.ccv_placeholder' })

    // 輸入信用卡資料
    let options

    if (basket.isStoreDelivery && this.isCampaignCCBMerchant) {
      const numberValidation = cardValidator.number(card.number)
      const holderValidation = cardValidator.cardholderName(card.holder)
      const expirationValidation = cardValidator.expirationDate(card.expiration)
      const cvvValidation = cardValidator.cvv(card.cvv)
      const cardType = numberValidation.card && numberValidation.card.niceType
      const invalidNumber = card.number.length >= 16 && !numberValidation.isValid
      const invalidHolder = !holderValidation.isValid
      const invalidExpiration = card.expiration.length === 4 && !expirationValidation.isValid
      const invalidCVV = card.cvv.length >= 3 && !cvvValidation.isValid
      const isValid = numberValidation.isValid && holderValidation.isValid && expirationValidation.isValid && cvvValidation.isValid

      const CCBFooterStyle = isValid
        ? cx(classes['takeaway-summary-footer'])
        : cx(classes['takeaway-summary-footer-invalid'])

      const groupString = (string, members) => {
        // members: how may merbers in a group.
        const arr = []
        const groups = Math.ceil(string.length / members)
        let i
        for (i = 0; i < groups; i++) {
          arr.push(string.substr(i * members, members))
        }
        return arr
      }

      const numberGroups = groupString(card.number, 4)
      const expirationGroups = groupString(card.expiration, 2)

      options = (
        <div>
          <div
            className={ paymentOptionStyle }
            onClick={ () => {
              this.handleSetStatePaymentMethod('creditCard')
            } }
          >
            <div title={ creditCardPaymentText } className={ creditCardStyle } />
          </div>
          <div className={ paymentOptionStyle } style={ { height: '300px' } }>
            {/* Card Number */ }
            <input
              className={ cx(telInputStyle, { [classes.invalid]: invalidNumber }) }
              type="text"
              value={ numberGroups.join(' ') }
              maxLength={ 16 + numberGroups.length - 1 }
              placeholder={ _cardNumPlaceholderText }
              onChange={ (e) =>
                this.setState({
                  card: {
                    ...card,
                    number: e.target.value.replace(/[^0-9.]/g, ''), // allow number only, replace anything else to be an empty string.,
                  },
                }) }
            />

            {/* Card Holder */ }
            <input
              className={ cx(telInputStyle, { [classes.holderValidation]: invalidHolder }) }
              type="text"
              value={ card.holder }
              placeholder={ _cardHolderPlaceholderText }
              onChange={ (e) =>
                this.setState({
                  card: {
                    ...card,
                    holder: e.target.value,
                  },
                }) }
            />

            <Flex style={ { overflow: 'visible' } }>
              {/* Expired Date */ }
              <Flex.Item>
                <input
                  className={ cx(telInputStyle, { [classes.invalid]: invalidExpiration }) }
                  type="text"
                  value={ expirationGroups.join(' / ') }
                  maxLength={ 4 + 3 }
                  placeholder={ _cardExpirationPlaceholderText }
                  onChange={ (e) =>
                    this.setState({
                      card: {
                        ...card,
                        expiration: e.target.value.replace(/[^0-9.]/g, ''), // allow number only, replace anything else to be an empty string.,
                      },
                    }) }
                />
              </Flex.Item>

              {/* cvv */ }
              <Flex.Item>
                <input
                  className={ cx(telInputStyle, { [classes.invalid]: invalidCVV }) }
                  type="text"
                  value={ card.cvv }
                  maxLength="3"
                  placeholder={ _cardCVVPlaceholderText }
                  onChange={ (e) =>
                    this.setState({
                      card: {
                        ...card,
                        cvv: e.target.value.replace(/[^0-9.]/g, ''), // allow number only, replace anything else to be an empty string.,
                      },
                    }) }
                />
              </Flex.Item>
            </Flex>

            {/* Pay Button */ }
            <div
              className={ CCBFooterStyle }
              onClick={
                isValid
                  ? () => {
                    const CCBBins = CCBCards.map((c) => c.bin)
                    const isCCBCard = CCBBins.includes(card.number.substr(0, 6))
                    if (!isCCBCard) return updateDisplayCCBCardOnlyDialog(true)
                    this.payWithCCBCreditCardInfo(cardType)
                  }
                  : null
              }
            >
              { _payText }
            </div>
            { this.state.isShowReorderBtn && (
              <div
                className={ reorderStyle }
                onClick={ () => {
                  const { history } = this.props
                  const path = '/home'
                  history.push(path)
                  console.info('route changed', path)
                  this.setState({ paymentMethod: null })
                } }
              >
                {_reorderText }
              </div>
            ) }
          </div>
        </div>
      )
    } else if (this.state.paymentMethod === 'creditCard') {
      const optionHeading = (
        <div
          className={ paymentOptionStyle }
          onClick={ () => {
            this.handleSetStatePaymentMethod('creditCard')
          } }
        >
          <div title={ creditCardPaymentText } className={ creditCardStyle } />
        </div>
      )

      const { amount } = this.state
      const formStyle = {
        paymentOptionStyle,
        telInputStyle,
        selectStyle,
        validStyle: cx(classes['takeaway-summary-footer']),
        invalidStyle: cx(classes['takeaway-summary-footer-invalid']),
      }
      const cardPlaceholder = {
        card: _cardNumPlaceholderText,
        name: _cardHolderPlaceholderText,
        exp: _cardExpirationPlaceholderText,
        cvv: _cardCVVPlaceholderText,
        pay: _payText,
      }

      switch (this.props.paymentGateway) {
        case PAYMENT_GATEWAY_FIRST_DATA:
          options = (
            <FirstDataCreditCard
              optionHeading={ optionHeading }
              cardPlaceholder={ cardPlaceholder }
              formStyle={ formStyle }
              amount={ amount }
              submit={ this.submit }
            />
          )
          break

        case PAYMENT_GATEWAY_STRIPE:
        default:
          options = (
            <div>
              {optionHeading }
              <div className={ paymentOptionStyle } style={ { height: '300px' } }>
                {/* Card Number */ }
                <CardNumberElement
                  className={ telInputStyle }
                  onChange={ this.handleCardNumberChanged }
                  placeholder={ _cardNumPlaceholderText }
                />

                {/* Card Holder */ }
                <input
                  className={ telInputStyle }
                  placeholder={ _cardHolderPlaceholderText }
                  onChange={ this.handleUpdateCardHolder }
                />

                <Flex style={ { overflow: 'visible' } }>
                  {/* Expired Date */ }
                  <Flex.Item>
                    <CardExpiryElement
                      className={ selectStyle }
                      onChange={ this.handleCardExpireDateChanged }
                      placeholder={ _cardExpirationPlaceholderText }
                    />
                  </Flex.Item>

                  {/* CVC */ }
                  <Flex.Item>
                    <CardCVCElement
                      className={ selectStyle }
                      onChange={ this.handleCardCVCChanged }
                      placeholder={ _cardCVVPlaceholderText }
                    />
                  </Flex.Item>
                </Flex>

                {/* Pay Button */ }
                <div className={ footerStyle } onClick={ valid ? this.payWithCreditCardInfo : null }>
                  { _payText }
                </div>
                { this.state.isShowReorderBtn && (
                  <div
                    className={ reorderStyle }
                    onClick={ () => {
                      const { history } = this.props
                      const path = '/home'
                      history.push(path)
                      console.info('route changed', path)
                      this.setState({ paymentMethod: null })
                    } }
                  >
                    {_reorderText }
                  </div>
                ) }
              </div>
            </div>
          )
          break
      }
    } else if (this.state.paymentMethod === 'wechatPay' && this.state.displayQRC) {
      const optionHeading = (
        <div
          className={ paymentOptionStyle }
          onClick={ () => {
            this.handleSetStatePaymentMethod('wechatPay')
          } }
        >
          <div title={ weChatPayPaymentText } className={ weChatPayStyle } />
        </div>
      )
      options = (
        <QrcPayment
          submit={ this.submit }
          handleDisplayQRC={ this.handleDisplayQRC }
          QRCType={ this.state.QRCType }
          optionHeading={ optionHeading }
          qrcode={ this.state.qrcode }
          orderID={ this.state.outTradeNo }
          syssn={ this.state.syssn }
        />
      )
    } else if (this.state.paymentMethod === 'aliPay' && this.state.displayQRC) {
      const optionHeading = (
        <div
          className={ paymentOptionStyle }
          onClick={ () => {
            this.handleSetStatePaymentMethod('aliPay')
          } }
        >
          <div title={ aliPayPaymentText } className={ aliPayStyle } />
        </div>
      )
      options = (
        <QrcPayment
          submit={ this.submit }
          handleDisplayQRC={ this.handleDisplayQRC }
          QRCType={ this.state.QRCType }
          optionHeading={ optionHeading }
          qrcode={ this.state.aliPayload.payUrl }
          orderID={ this.state.aliPayload.outTradeNo }
          syssn={ this.state.aliPayload.syssn }
        />
      )
    } else {
      const comingSoonText = intl.formatMessage({ id: 'takeaway.payment.method.comingsoon' })
      const comingSoonRemark = (
        <div
          style={ {
            position: 'absolute',
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            paddingRight: '24px',
            boxSizing: 'border-box',
            backgroundColor: 'rgba(0,0,0,0.4)',
            color: 'rgb(255, 255, 255)',
            textAlign: 'right',
            left: '0',
            top: '0',
            height: '100%',
          } }
        >
          <span
            style={ {
              fontSize: '20px',
            } }
          >
            { comingSoonText }
          </span>
        </div>
      )

      options = []

      const creditCardDisabledStyles = {}
      if (shouldShowCashBtn) {
        const cashPaymentBtn = (
          <div
            key="cash-payment-btn"
            className={ paymentOptionStyle }
            onClick={ () => {
              this.handleSetStatePaymentMethod('cash')
              this.setState({ displayPayCashDialog: true })
            } }
          >
            <div
              style={ {
                height: '50px',
                lineHeight: '50px',
                fontSize: '20px',
                marginLeft: '10px',
              } }
            >
              { cashPaymentText }
            </div>
          </div>
        )

        // creditCardDisabledStyles = { "background": "#999", "opacity": "0.8" }
        options.push(cashPaymentBtn)
      }
      if (window.location.hostname.includes('localhost') || window.location.hostname.includes('takebypass')) {
        const bypassPaymentBtn = (
          <div
            key="bypass-payment-btn"
            onClick={ () => {
              this.handleSetStatePaymentMethod('bypass')
              this.submit({ payment: 'bypass', source: 'dimdan' })
            } }
            className={ paymentOptionStyle }
          >
            <div
              style={ {
                height: '50px',
                lineHeight: '50px',
                fontSize: '20px',
                marginLeft: '10px',
              } }
            >bypass payment</div>
          </div>
        )

        options.push(bypassPaymentBtn)
      }
      // if (shouldShowAliPayBtn) {
      //   const AliPaymentBtn = (
      //     <div
      //       key = "alipay-payment-btn"
      //       onClick = { () => {
      //         this.handleSetStatePaymentMethod('aliPay')
      //         this.payWithAlipay()
      //       }}
      //       className = {paymentOptionStyle}
      //     >
      //       <div title={aliPayPaymentText} className={aliPayStyle} />
      //     </div >
      //   )
      //   options.push(AliPaymentBtn)
      // }
      // if (shouldShowWeChatPayBtn) {
      //   // WeChat Pay Btn
      //   const WeChatPaymentBtn = (
      //     <div
      //       key="wechatpay-payment-btn"
      //       onClick={() => {
      //         this.handleSetStatePaymentMethod('wechatPay')
      //         this.payWithWeChatPay()
      //       }}
      //       className={paymentOptionStyle}
      //     >
      //       <div title={weChatPayPaymentText} className={weChatPayStyle} />
      //     </div>
      //   )
      //   options.push(WeChatPaymentBtn)
      // }
      // if (shouldShowFpsBtn) {
      //   // WeChat Pay Btn
      //   const FPSPaymentBtn = (
      //     <div
      //       key="fps-payment-btn"
      //       onClick={() => {
      //         // FPS Payment
      //       }}
      //       className={paymentOptionStyle}
      //     >
      //       <div title={fpsPaymentText} className={fpsStyle} />
      //     </div>
      //   )
      //   options.push(FPSPaymentBtn)
      // }

      if (this.shouldShowCreditCard(merchant)) {
        const creditCardComingSoon =
          merchant.setting.takeawayCashPayment && !merchant.setting.takeawayCreditCardPayment
        let className = paymentOptionStyle
        if (creditCardComingSoon) {
          className = disabledPaymentOptionStyle
        }
        options.push(
          <div
            key="credit-card-payment-btn"
            className={className}
            style={creditCardDisabledStyles}
            onClick={() => {
              this.handleSetStatePaymentMethod('creditCard')
            }}
          >
            <div title={creditCardPaymentText} className={creditCardStyle} />
            {creditCardComingSoon && comingSoonRemark}
          </div>,
        )
      }

      if (shouldShowApplePayBtn) {
        let className = paymentOptionStyle
        const { amount } = this.state
        const creditCardComingSoon =
          merchant.setting.takeawayCashPayment && !merchant.setting.takeawayCreditCardPayment

        switch (this.props.paymentGateway) {
          case PAYMENT_GATEWAY_FIRST_DATA:
            // options.push(
            //   <FirstDataApplePay
            //     key="apple-pay-payment-btn"
            //     buttonClass={className}
            //     amount={amount}
            //     submit={this.submit}
            //   />
            // );
            // break;
            break
          default:
            if (creditCardComingSoon) {
              className = disabledPaymentOptionStyle
            }
            options.push(
              <div
                key="apple-pay-payment-btn"
                onClick={() => {
                  this.handleSetStatePaymentMethod('applePay')
                  this.payWithApplePay()
                }}
                className={className}
                style={creditCardDisabledStyles}
              >
                <div title={applePayPaymentText} className={applePayStyle} />
                {creditCardComingSoon && comingSoonRemark}
              </div>,
            )
        }
      }

      if (shouldShowGooglePayBtn) {
        let className = paymentOptionStyle
        const { amount } = this.state
        const creditCardComingSoon =
          merchant.setting.takeawayCashPayment && !merchant.setting.takeawayCreditCardPayment

        switch (this.props.paymentGateway) {
          case PAYMENT_GATEWAY_FIRST_DATA:
            // options.push(<FirstDataGooglePay
            //   key='google-pay-payment-btn'
            //   buttonClass={ className }
            //   amount={ amount }
            //   submit={ this.submit }/>)
            // break
            break
          default:
            if (creditCardComingSoon) {
              className = disabledPaymentOptionStyle
            }
            options.push(
              <div
                key="google-pay-payment-btn"
                onClick={() => {
                  this.handleSetStatePaymentMethod('googlePay')
                  this.payWithGooglePay()
                }}
                className={className}
                style={creditCardDisabledStyles}
              >
                <div title={googlePayPaymentText} className={gPayStyle} />
                {creditCardComingSoon && comingSoonRemark}
              </div>,
            )
            break
        }
      }
    }

    const topVal = this.renderRecentPaymentOption() ? '180px' : '80px'

    return (
      <div className={optionStyle} style={{ top: topVal }}>
        {options}
      </div>
    )
  }

  handlePrevBtnClick = () => {
    this.setState({ paymentMethod: null })
  }

  renderRecentPaymentOption = () => {
    const { recentPaymentInfo, merchant } = this.props

    const { classes, intl } = this.props
    const optionStyle = cx(classes['recent-payment-option-wrap'])
    const paymentOptionStyle = cx(classes['payment-option'])
    const recentPaymentOptionContentStyle = cx(classes['recent-payment-option-content'])
    const payWithRecentMethodText = intl.formatMessage({ id: 'takeaway.summary.pay.with.recent.method' })

    // const valid = this.state.isCardNumComplete &&
    //   this.state.isCardExpireDateComplete &&
    //   this.state.isCardCVCComplete &&
    //   !this.state.isSubmittingPayment
    // let footerStyle = valid ? cx(classes['takeaway-summary-footer']) : cx(classes['takeaway-summary-footer-invalid'])

    if (!recentPaymentInfo) {
      return ''
    }
    if (merchant.setting.takeawayCashPayment && !merchant.setting.takeawayCreditCardPayment) {
      return ''
    }

    const paymentMethodStyle = cx(classes[`recent-payment-option-${recentPaymentInfo.method}-card`])
    if (this.props.paymentGateway === PAYMENT_GATEWAY_FIRST_DATA) {
      // TODO: recent
      return ''
    }
    if (this.props.paymentGateway === PAYMENT_GATEWAY_STRIPE) {
      return (
        <div className={optionStyle}>
          <div
            className={paymentOptionStyle}
            onClick={() => {
              this.payWithRecentMethod()
            }}
          >
            <div className={paymentMethodStyle}>
              <div className={recentPaymentOptionContentStyle}>{payWithRecentMethodText}</div>
            </div>
          </div>
        </div>
      )
    }

    return ''
  }

  renderSoldOutDialog = () => {
    const { intl, history, soldOut, orders } = this.props

    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const continueButtonText = intl.formatMessage({ id: 'dialog.continue_btn' })
    const soldOutText = intl.formatMessage({ id: 'dialog.sold_out_title' })
    const allSoldOutText = intl.formatMessage({ id: 'dialog.all_sold_out_title' })

    // > 當所選商品皆已售完。
    const isAllSelectedItemsSoldOut = !soldOut.soldOutCanContinue

    // > 當所選商品皆已售完，顯示不同的 title。
    const title = (
      <p
        style={{
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        {isAllSelectedItemsSoldOut ? allSoldOutText : soldOutText}
      </p>
    )

    // message
    const soldOutItems = _(soldOut.soldOutItems)
      .groupBy((o) => [o.menuID, o.setMenuID, o.setMenuIndex].join('|')) // {uid:[]item}
      .map((items, i) => {
        const item = items[0]
        let _text = item.name
        if (item.setMenuID) {
          const setName = orders.filter((o) => {
            return _.find(o.items, { dishId: item.setMenuID })
          })[0].dish
          _text = setName + ' ' + item.name
        }

        // _text += (' (剩' + soldOut.soldOutInventory[item.menuID] + '個)')
        return (
          <li key={i} style={{ textAlign: 'left' }}>
            {_text}
          </li>
        )
      })
      .value()

    const message = soldOutItems

    const goBackButton = {
      text: goBackButtonText,
      onPress: () => {
        this.props.updateDisplaySoldOutDialogTakeawayPaymentSummary(false)
        this.props.updateSoldOutItems(null)
        const path = '/basket/checkout'
        history.push(path)
        this.setState({ paymentMethod: null })
      },
    }
    const continueButton = {
      text: continueButtonText,
      onPress: () => {
        this.props.updateDisplaySoldOutDialogTakeawayPaymentSummary(false)
        this.props.updateSoldOutItems(null)
        this.setState({ ignoreUnavailable: true }, () => {
          switch (this.state.paymentMethod) {
            case 'recent':
              this.payWithRecentMethod()
              break
            case 'cash':
              this.submitByCash()
              break
            case 'creditCard':
              this.payWithCreditCardInfo()
              break
            case 'applePay':
              this.payWithApplePay()
              break
            case 'googlePay':
              this.payWithGooglePay()
              break
            case 'bypass':
              this.submit({ payment: 'bypass', source: 'dimdan' })
              break
            case 'wechatPay':
              this.payWithWeChatPay()
              break
            case 'aliPay':
              this.payWithAlipay()
              break
            default:
              break
          }
        })
      },
    }

    // > 當所選商品皆已售完，dialogButton 只有返回沒有繼續
    const dialogButtons = isAllSelectedItemsSoldOut ? [goBackButton] : [goBackButton, continueButton]

    Modal.alert(title, message, dialogButtons)
  }

  renderCCBCardOnlyDialog = () => {
    const { intl, history } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })

    const title = <p style={{ lineHeight: 1.5, margin: 0 }}>CCB Card Only</p>

    const message = (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '0px 16px' }}>
        <p style={{ margin: 0, fontSize: 12 }}>Visa Card</p>
        <p style={{ margin: 0, fontSize: 12 }}>431784 VISA Platinum</p>
        <p style={{ margin: 0, fontSize: 12 }}>436505 VISA Infinite</p>
        <p style={{ margin: 0, fontSize: 12 }}>438617 VISA Classic</p>
        <p style={{ margin: 0, fontSize: 12 }}>438618 VISA Gold</p>
        <br />
        <p style={{ margin: 0, fontSize: 12 }}>MasterCard</p>
        <p style={{ margin: 0, fontSize: 12 }}>554639 MC Platinum</p>
        <p style={{ margin: 0, fontSize: 12 }}>554724 MC Platinum</p>
        <p style={{ margin: 0, fontSize: 12 }}>559959 MC World</p>
        <br />
        <p style={{ margin: 0, fontSize: 12 }}>UnionPay</p>
        <p style={{ margin: 0, fontSize: 12 }}>622675 UnionPay Gold</p>
        <p style={{ margin: 0, fontSize: 12 }}>622676 UnionPay Platinum</p>
        <p style={{ margin: 0, fontSize: 12 }}>622677 UnionPay Diamond</p>
        <p style={{ margin: 0, fontSize: 12 }}>624329 UnionPay Diamond (Business)</p>
      </div>
    )

    const goBackButton = {
      text: goBackButtonText,
      onPress: () => {
        this.props.updateDisplayCCBCardOnlyDialog(false)
        const path = '/basket/checkout'
        history.push(path)
        this.setState({ paymentMethod: null })
      },
    }
    Modal.alert(title, message, [goBackButton])
  }

  render () {
    const { classes, onCloseBtnClick, intl } = this.props
    const wrapStyle = cx(classes.wrap)
    const headerStyle = cx(classes.header)
    const closeBtnStyle = cx(classes['close-button'])
    const prevBtnStyle = cx(classes['prev-button'])
    const _paymentText = intl.formatMessage({ id: 'checkout.hand.up.pay' })
    let topBtn

    const { merchant, orders, basket } = this.props
    const { discountedTotal, discountedTotalWithShipping } = helpers.calculate.calculateOrders(
      orders,
      merchant,
      basket.discount,
      basket.shipping,
    )
    let amount = discountedTotal
    if (basket.isShop || basket.isStoreDelivery) {
      amount = discountedTotalWithShipping
    }

    if (this.state.paymentMethod === 'creditCard') {
      topBtn = <div onClick={this.handlePrevBtnClick} className={prevBtnStyle} />
    } else {
      topBtn = <div onClick={onCloseBtnClick} className={closeBtnStyle} />
    }

    let loading = ''
    if (this.state.paymentMethod === 'recent') {
      loading = (
        <div
          style={{
            position: 'fixed',
            height: '100%',
            width: '100%',
            top: '0px',
          }}
        >
          <div
            style={{
              height: '100%',
              position: 'absolute',
              width: '100%',
              textAlign: 'center',
              top: '0px',
              background: '#000',
              opacity: '0.2',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: 'calc(50% - 16px)',
              left: 'calc(50% - 16px)',
            }}
          >
            <ActivityIndicator size="large" />
          </div>
        </div>
      )
    }

    const confirmPayByCashText = intl.formatMessage({ id: 'checkout.pay.by.cash.confirm' })
    const payCashDialog = (
      <DialogComponent
        triggerModal={(isConfirmed) => {
          if (isConfirmed) {
            this.submitByCash()
          }
          this.setState({ displayPayCashDialog: false })
          // this.setState({ paymentMethod: null })
        }}
        dialogType="confirm"
        title={confirmPayByCashText}
      />
    )
    return (
      <div style={{ height: this.state.innerHeight }} className={wrapStyle}>
        {topBtn}
        <div className={headerStyle}>
          {_paymentText} ${amount}
        </div>
        {this.renderRecentPaymentOption()}
        {this.state.paymentReady && this.renderPaymentOptions()}
        {this.renderToast()}
        {loading}
        {this.state.displayPayCashDialog && payCashDialog}
      </div>
    )
  }
}

export default injectSheet(styles)(TakeawayPaymentSummaryComponent)



// WEBPACK FOOTER //
// ./src/components/TakeawayPaymentSummary.js